<template>
  <v-container fluid class="login">
    <v-form ref="form">
      <v-row justify="center" align="center">
        <v-col cols="12" md="6" lg="6">
          <v-container>
            <v-row wrap>
              <v-col cols="12" class="text-center"></v-col>
              <v-col cols="12" class="headline">RECUPERAR CONTRASEÑA</v-col>
              <v-col cols="12">
                <v-divider></v-divider>
                <br />
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="email" v-bind="props"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn
                  block
                  color="accent"
                  class="rakken-button black--text"
                  @click.prevent="reset()"
                  :loading="loading"
                  >ENVIAR</v-btn
                >
              </v-col>

              <v-col cols="12" class="text-center">
                <v-btn text to="/login">Regresar al login</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { app } from "@/config/globals";
import { emailValid, required } from "@/services/ValidatorService";

export default {
  data() {
    return {
      name: app.name,
      email: "",
      loading: false,
      props: {
        outline: true,
        "single-line": true,
        "prepend-inner-icon": "fas fa-envelope",
        label: "Correo electrónico",
        rules: [emailValid, required]
      }
    };
  },
  methods: {
    ...mapActions("user", ["sendPasswordResetEmail"]),
    async reset() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        await this.sendPasswordResetEmail(this.email);
        this.loading = false;
        this.email = "";
        this.$refs.form.reset();
      }
    }
  }
};
</script>

<style>
.v-btn--contained {
  -webkit-box-shadow: unset;
  box-shadow: unset;
}
</style>
